const DEFAULT_ADDRESS_SEARCH_ELEMENT = "personal-information__address";

const DEFAULT_ADDRESS_VARIABLE_NAME = "address";
const DEFAULT_ZIP5_VARIABLE_NAME = "zip";

const GOOGLE_MAPS_API_TYPES = {types: ["geocode"]};

const GOOGLE_MAPS_FIELD_ADDRESS_COMPONENT = "address_component";
const GOOGLE_MAPS_FIELD_GEOMETRY = "geometry";

const GOOGLE_MAPS_PLACE_SHORT_NAME = "short_name";

const GOOGLE_MAPS_PLACE_TYPE_ZIP5 = "postal_code";
const GOOGLE_MAPS_PLACE_TYPE_ZIP4 = "postal_code_suffix";
const GOOGLE_MAPS_PLACE_TYPE_COUNTRY = "country";
const GOOGLE_MAPS_PLACE_TYPE_STATE = "administrative_area_level_1";
const GOOGLE_MAPS_PLACE_TYPE_COUNTY = "administrative_area_level_2";
const GOOGLE_MAPS_PLACE_TYPE_CITY = "locality";
const GOOGLE_MAPS_PLACE_TYPE_STREET_NUM = "street_number";
const GOOGLE_MAPS_PLACE_TYPE_STREET_NAME = "route";


export default {
  DEFAULT_ADDRESS_SEARCH_ELEMENT,
  DEFAULT_ADDRESS_VARIABLE_NAME,
  DEFAULT_ZIP5_VARIABLE_NAME,
  GOOGLE_MAPS_API_TYPES,
  GOOGLE_MAPS_FIELD_ADDRESS_COMPONENT,
  GOOGLE_MAPS_FIELD_GEOMETRY,
  GOOGLE_MAPS_PLACE_SHORT_NAME,
  GOOGLE_MAPS_PLACE_TYPE_ZIP5,
  GOOGLE_MAPS_PLACE_TYPE_ZIP4,
  GOOGLE_MAPS_PLACE_TYPE_COUNTRY,
  GOOGLE_MAPS_PLACE_TYPE_STATE,
  GOOGLE_MAPS_PLACE_TYPE_COUNTY,
  GOOGLE_MAPS_PLACE_TYPE_CITY,
  GOOGLE_MAPS_PLACE_TYPE_STREET_NUM,
  GOOGLE_MAPS_PLACE_TYPE_STREET_NAME
}